<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 370.4 370.4" style="overflow:visible;enable-background:new 0 0 370.4 370.4;"
         xml:space="preserve">
            <path style="fill:#D70000;" d="M185.2,0c102.3,0,185.2,82.9,185.2,185.2c0,102.3-82.9,185.2-185.2,185.2C82.9,370.4,0,287.5,0,185.2
        c0-0.5,0-1.1,0-1.6C1,82,83.6,0.1,185.2,0z M185.2,106.1l-0.9-1.4c-3.3-5.6-7-11-11.1-16.1c-4.7-6-10.1-11.3-16-16.1
        c-3.4-2.7-7.2-5.1-11.2-6.9c-3.7-1.7-7.8-2.8-11.9-3c-6.2-0.4-12.3,1.6-17.1,5.7c-4,3.3-7.1,7.5-9.1,12.3c-2.2,5-2.6,10.6-1.2,15.8
        c1.1,4,3.1,7.7,5.7,10.9c3.3,3.9,7.1,7.3,11.4,10c5.1,3.3,10.6,6.1,16.2,8.2c13.3,5.2,27.3,8.2,41.5,8.8c3.9,0.1,7.9,0.1,11.8-0.2
        c15.5-1.2,30.6-5.2,44.6-11.9c5.7-2.7,11-6.2,15.7-10.3c3.5-3,6.3-6.7,8.3-10.8c2.6-5.3,3.3-11.3,1.7-17c-1.3-4.9-3.9-9.4-7.5-13.1
        c-6-6.9-15.4-9.9-24.3-7.7c-4.9,1.2-9.6,3.2-13.8,6.1c-4.6,3-8.9,6.5-12.8,10.4c-7.4,7.4-13.8,15.7-19.1,24.6L185.2,106.1z
         M173.7,226.9c-1.9-0.4-65.3-0.5-73.5-0.2c-0.5,0-1,0.1-1.4,0.2v11.7c0,11.4,0,22.8,0,34.3c0,5.5,3.7,10.3,9.1,11.5
        c1.3,0.2,2.6,0.3,3.9,0.3h60.6l1.3-0.2V226.9z M271.7,226.9c-0.8-0.3-1.7-0.5-2.5-0.3H198c-0.4,0-0.8,0.2-1.2,0.2c0,0.2,0,0.4,0,0.7
        v55.9c0,0.3,0,0.5,0,0.8l0,0l0.2,0.3h2.1h60c1.1,0,2.2-0.1,3.3-0.3c5.4-1.2,9.1-6,9.1-11.5c0-14.7,0-29.5,0-44.2L271.7,226.9z
         M173.7,145.6h-2.2h-61.5c-3.2,0.1-6.3,1.6-8.4,4.1c-1.9,2.2-2.9,4.9-2.8,7.8v44.2c-0.1,0.7,0,1.4,0.4,1.9h73.2l1.3-0.2L173.7,145.6
        z M196.7,145.6c0,1,0,1.7,0,2.5c0,17.7,0,35.3,0,53.1c0,0.4,0,0.8,0,1.1c0,0.4,0,0.8,0.2,1.4h73.4c0.4,0,0.8,0,1.4-0.2v-28.1
        c0-6.1,0-12.1,0-18.2c0-5.1-3.4-9.6-8.3-11.1c-1.4-0.4-2.8-0.6-4.3-0.5L196.7,145.6L196.7,145.6z"/>
    </svg>
</template>

<script>
    export default {
        name: 'icon-gift'
    }
</script>